import { auth } from '../../base';
import { CALL_API } from './../../middlewares/api';
//import moment from 'moment';

const userRoles = ({displayName, email, emailVerified}) => ({
  [CALL_API]: {
    type: 'USER_ROLES',
    endpoint: 'context',
    authenticated: true,
    config: {
      method: 'GET'
    }
  },
  value: {user:{displayName, email}}
});

const signOutUser = () => ({
  type: 'SIGN_OUT_USER'
});

const waitAuthUser = () => ({
  type: 'AUTH_USER_WAIT'
});

export const verifyAuth = (cb) => dispatch => {
  dispatch(waitAuthUser());

  auth.onAuthStateChanged(user => {
    if (user) {
      dispatch(userRoles(user));
      cb();
    } else {
      dispatch(signOutUser());
    }
  });
};

const onSolicitaAcesso = value => ({
  [CALL_API]: {
    type: 'CREATE_NEW_USER',
    endpoint: 'roles',
    authenticated: true,
    config: {
      method: 'POST',
      redirect: 'follow',
      body: {
        ...value
      }
    }
  },
  value
});

export default {
  onSolicitaAcesso
};



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js